<template>
  <Modal title="凭证/附件展示" v-model="showModal" @on-visible-change="handleModalVisibleChange" width="80%" :footer-hide="true">
    <template>
      <div class="carousel-container">
        <el-carousel indicator-position="outside" ref="carousel" :initial-index="initialIndex">
          <el-carousel-item v-for="(item, index) in showList" :key="item" class="carousel-item">
            <img
              :src="item"
              class="preview-image"
              @click="handleImageClick(index)"
              :alt="'Image ' + (index + 1)"
            >
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 图片查看器 -->
      <div v-show="showViewer" class="image-viewer-wrapper" @click="closeViewer">
        <img
          :src="currentImage"
          class="viewer-image"
          @touchstart="handleTouchStart"
          @touchmove="handleTouchMove"
          @touchend="handleTouchEnd"
        >
        <div class="viewer-toolbar">
          <button class="viewer-button" @click.stop="closeViewer">关闭</button>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
  export default {
    name: 'ShowImageCarousel',
    props: {
      imgList: {
        type: Array,
        default: () => []
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showModal: false,
        showList: this.imgList,
        showViewer: false,
        currentImage: '',
        initialIndex: 0,
        // 触摸事件相关数据
        touchStartX: 0,
        touchStartY: 0,
        touchStartTime: 0
      }
    },
    watch: {
      value (val) {
        if (val) {
          this.showModal = val
        }
      },
      showModal (val) {
        if (val === false) {
          this.$emit('on-close')
        }
      },
      imgList (val) {
        if (val) {
          this.showList = val
        }
      }
    },
    methods: {
      handleImageClick (index) {
        this.initialIndex = index
        this.currentImage = this.showList[index]
        this.showViewer = true
      },
      closeViewer () {
        this.showViewer = false
      },
      handleModalVisibleChange (visible) {
        if (!visible) {
          this.showViewer = false
        }
      },
      // 触摸事件处理
      handleTouchStart (e) {
        const touch = e.touches[0]
        this.touchStartX = touch.clientX
        this.touchStartY = touch.clientY
        this.touchStartTime = new Date().getTime()
      },
      handleTouchMove (e) {
        // 阻止默认的滚动行为，允许图片缩放
        if (e.touches.length > 1) {
          e.preventDefault()
        }
      },
      handleTouchEnd (e) {
        const touchEndTime = new Date().getTime()
        const touchDuration = touchEndTime - this.touchStartTime

        // 如果是快速点击（300ms内），则切换查看器状态
        if (touchDuration < 300) {
          const touch = e.changedTouches[0]
          const deltaX = Math.abs(touch.clientX - this.touchStartX)
          const deltaY = Math.abs(touch.clientY - this.touchStartY)

          // 确保是点击而不是滑动
          if (deltaX < 10 && deltaY < 10) {
            this.closeViewer()
          }
        }
      }
    }
  }
</script>

<style scoped>
.carousel-container {
  position: relative;
  height: 70vh;
}

.carousel-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70vh;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
  object-fit: contain;
}

.image-viewer-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.viewer-image {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  touch-action: manipulation;
}

.viewer-toolbar {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.viewer-button {
  padding: 10px 20px;
  background-color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.viewer-button:hover {
  background-color: #f0f0f0;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .viewer-image {
    max-width: 100vw;
    max-height: 100vh;
  }

  .viewer-button {
    padding: 15px 30px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// ShowImageCarousel.vue?60d8728b